import React from "react";
import history from "../history";

const WaitlistSignup = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <div>
        <h2 className="pt-10 text-center">You're on the waitlist!</h2>
        <p className="pl-0">Thanks for joining!</p>
        <button
          className={`py-2 px-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 hover:text-coolGray-100 hover:bg-blue-500`}
          onClick={() => history.push("/")}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default WaitlistSignup;
